// extracted by mini-css-extract-plugin
var _1 = "fa9e1a";
var _2 = "bcf8d9";
export { _1 as "audio_player_head", _2 as "spinner" }
